module.exports = __webpack_public_path__ + "static/media/wagz-logo.6e0fbf79.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wagz-logo.png
// module id = 355
// module chunks = 0